import { buildProps as o } from "./index601.js";
import { iconPropType as t } from "./index606.js";
const p = o({
  disabled: Boolean,
  currentPage: {
    type: Number,
    default: 1
  },
  prevText: {
    type: String
  },
  prevIcon: {
    type: t
  }
}), i = {
  click: (e) => e instanceof MouseEvent
};
export {
  i as paginationPrevEmits,
  p as paginationPrevProps
};
